import { create } from "zustand";
import { INiche } from "@/common/services/types";

interface ITrendingNichesState {
  trendingNiches: INiche[];
  setTrendingNiches: (niches: INiche[]) => void;
}

export const useTrendingNichesStore = create<ITrendingNichesState>(
  (set) => ({
    trendingNiches: [],
    setTrendingNiches: (trendingNiches: INiche[]) => set(() => ({ trendingNiches })),
  }),
);
